﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M13.5,23.5H1.5a1,1,0,0,1-1-1V1.5a1,1,0,0,1,1-1H14.793A1,1,0,0,1,15.5.794L19.207,4.5a1,1,0,0,1,.293.707V9.5"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M9.5,15.5a5,5,0,1,1,5-5"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M9.5 7.501L9.5 10.501 11.5 10.501"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M12.500 17.030 A4.529 4.529 0 1 0 21.558 17.030 A4.529 4.529 0 1 0
      12.500 17.030 Z"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M23.5 23.501L20.252 20.253"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
</svg>
